<template>
  <div>
    <div
      v-if="loading"
    >
      <slot name="loading">
        Loading...
      </slot>
    </div>
    <div v-else-if="error" class="alert alert-danger">
      {{error}}
    </div>
    <div v-else-if="resultsCount">
      <slot :items="results.images">
        <MediaGrid
          :results="results.images"
          :wrap="wrap"
          :fill="fill"
          :on-open="onOpen"
          :get-to="getTo"
          :id="id"
          @update:id="$emit('update:id', $event)"
          @replaceState="$emit('replaceState', $event)"
        />
      </slot>
      <div v-if="showCount === 'auto' ? resultsCount < results.total : showCount">
        Showing {{resultsCount}}/{{results.total}} results.
        <router-link
          :to="{name: 'search', query: omit(query, ['limit'])}"
        >Show all</router-link>
      </div>
    </div>
    <div v-else>
      No results
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'

import MediaGrid from '@/components/MediaGrid.vue'
import { http } from '@/services/http.js'
import { omit } from '@/utils/omit.js'

export default {
  name: 'SearchResults',
  components: {
    MediaGrid,
  },
  props: {
    query: Object,
    id: null,
    wrap: null,
    fill: null,
    showCount: {
      type: [Boolean, String],
      default: 'auto',
    },
    onOpen: null,
    getTo: null,
    getResponse: {
      type: Function,
      default(params) {
        return http.get('content/search/v3/', {params})
      },
    }
  },
  data() {
    return {
      loading: false,
      results: null,
      error: null,
    }
  },
  computed: {
    resultsCount() {
      return get(this.results, 'images.length')
    },
  },
  watch: {
    query: 'fetchResults',
  },
  async created() {
    await this.fetchResults(this.query)
  },
  methods: {
    omit,
    refresh() {
      this.fetchResults(this.query)
    },
    async fetchResults(newVal, oldVal) {
      if (JSON.stringify(newVal) === JSON.stringify(oldVal)) { return }
      this.loading = true
      this.error = null
      this.results = await this.getResponse(newVal)
        .then(response => response.data)
        .catch(err => this.error = err)
        .finally(() => this.loading = false)
      this.$emit('update:results', this.results)
    },
  },
}
</script>
